import { createRouter, createWebHistory } from 'vue-router'
import { i18n } from '@/i18n.js'
import ChatLayout from '@/components/ChatLayout.vue' // <-- IMPORTANT: We use ChatLayout as the parent
import NotFound from '@/views/NotFound.vue'
import DashboardChats from '@/views/DashboardChats.vue'

const routes = [
  {
    path: '/',
    redirect: '/mne'
  },
  {
    // This is the main application shell for all dashboard routes.
    // It loads the sidebar, the arrow, and the main content area.
    path: '/:lang(en|mne)',
    component: ChatLayout,
    // All these children will render inside ChatLayout's <RouterView />
    children: [
      {
        // When a user visits /mne or /en, redirect them to a new chat screen.
        path: '',
        redirect: to => {
          return { path: `/${to.params.lang}/chats/new` }
        }
      },
      {
        // This handles both new chats and existing chat threads.
        // It will load DashboardChats.vue inside the ChatLayout component.
        path: 'chats/:threadId',
        name: 'dashboard-chats',
        component: DashboardChats
      }
      // You can add other child routes here in the future if needed
    ]
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: NotFound
  }
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  const lang = to.params.lang
  if (lang) i18n.global.locale.value = lang
  if (to.meta?.title) document.title = 'Supersteward | Air Montenegro'
  next()
})

export { router }